
import { AddressDetails } from '@/store/dueDiligence/types';
import { CPTextInput } from '@capital-platforms/cpui';
import Vue from 'vue';
import { Component, InjectReactive, Prop } from 'vue-property-decorator';
import { AccountOpeningMetadataData } from '@/endpoints/types';
import CPOpenAccountFormSubsection from '../open-account/form/CPOpenAccountFormSubsection.vue';
import CPOptionDropdownAdapter from '@/components/globals/adapters/CPOptionDropdownAdapter.vue';
import { metadataNumberAdapter } from '@/utils/metadataAdapters';

@Component({
    components: {
        CPTextInput,
        CPOptionDropdownAdapter,
        CPOpenAccountFormSubsection
    }
})
export default class CPDueDiligenceAccountHolderAddressDetails extends Vue {
    @Prop({ 
        type: Object as () => AddressDetails,
        required: true 
    })
    addressDetails!: AddressDetails

    @InjectReactive() 
    readonly viewOnly!: boolean;

    metadataNumberAdapter = metadataNumberAdapter;

    get rawCountries(): AccountOpeningMetadataData[] {
        return this.$store.getters['dueDiligence/rawCountries'];
    }
}
